<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :size="items?.length > 10 ? 'large' : 'medium'"
    title=""
  >
    <template #body>
      <div
        class="flex w-full flex-col gap-4 rounded-lg bg-white p-4 shadow-md dark:bg-gray-900"
      >
        <div
          class="flex flex-col gap-1 border-b border-gray-200 pb-2 dark:border-gray-700"
        >
          <h2
            class="capitalize-first text-xl font-semibold text-gray-900 dark:text-gray-100"
          >
            {{ $t('global.add_place_items') }}
          </h2>
          <p
            v-if="items?.length > 0"
            class="capitalize-first text-sm text-gray-500 dark:text-gray-400"
          >
            {{ $t('global.select_items') }}
          </p>
        </div>

        <template v-if="items?.length > 0">
          <div class="grid max-h-[50vh] grid-cols-1 gap-3 overflow-y-auto pr-1">
            <template v-for="item in items" :key="item.id">
              <div
                v-if="!itemIds?.includes(item.id)"
                class="dark:hover:bg-gray-750 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800"
              >
                <div class="flex items-center gap-2">
                  <input
                    v-model="selectedItems"
                    type="checkbox"
                    :value="item.id"
                    :disabled="!item.item_wiki_item_id"
                    class="text-primary focus:ring-primary h-4 w-4 rounded border-gray-300 focus:ring-offset-0 dark:border-gray-600"
                  />
                  <h3
                    class="text-sm leading-tight font-medium text-gray-800 dark:text-gray-100"
                  >
                    {{ $trans(item.name) }}
                  </h3>
                </div>
                <div v-if="!item.item_wiki_item_id">
                  <BaseButton
                    icon="link"
                    inverse-icon-order
                    size="extra-small"
                    color="warning"
                    :title="$t('global.link_to_intern_item')"
                    @click="handleLinkItem(item)"
                  />
                </div>
              </div>
            </template>
          </div>

          <div
            class="flex justify-end gap-2 border-t border-gray-200 pt-3 dark:border-gray-700"
          >
            <BaseButton
              :title="$t('button.cancel')"
              icon="times"
              inverse-icon-order
              color="warning"
              @click="() => (localIsModalOpen = false)"
            />
            <BaseButton
              :title="$t('button.add')"
              icon="plus"
              color="primary"
              inverse-icon-order
              :cursor="selectedItems.length > 0 ? 'pointer' : 'not-allowed'"
              :disabled="selectedItems.length === 0"
              @click="handleSelectedItems"
            />
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col gap-1 text-center">
            Il n y a pas d'article lié à ce lieu
          </div>
        </template>
      </div>

      <ItemByCategoryModal
        v-if="openItemsModal"
        v-model="selectedItem"
        :open="openItemsModal"
        :display-pack-tab="false"
        hide-stock-disponibility
        hide-quantity-input
        hide-price
        @close="openItemsModal = false"
        @selected-item="linkWikiItemToItem"
      />

      <AvailableLocationStockModal
        v-if="chooseStockFromLocationModal"
        v-model:is-modal-open="chooseStockFromLocationModal"
        v-model:original-request="originalRequest"
        v-model:new-orders="newOrders"
        :locations="locations"
        :supplier-with-orders="supplierOrderActive"
        :update-item="false"
        @selected-items="handleSaveWikiItemToDossier"
      />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import ItemByCategoryModal from '@ui/modal/item/ItemByCategoryModal.vue'
// import AvailableLocationStockModal from '@c/Stock/AvailableLocationStockModal.vue'

export default {
  name: 'PlaceWikiItemsModal',
  components: {
    // AvailableLocationStockModal,
    AvailableLocationStockModal: () =>
      import('@c/Stock/AvailableLocationStockModal.vue'),
    ItemByCategoryModal,
    BaseButton,
    BaseCenteredModal
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    placeId: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'update:is-modal-open', 'delete-model'],
  data() {
    return {
      selectedItems: [],
      openItemsModal: false,
      selectedItem: null,
      itemToLink: null,
      chooseStockFromLocationModal: false,
      locations: [],
      newOrders: [],
      originalRequest: null,
      supplierOrderActive: [],
      itemIds: [],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      dossier: 'dossier/getDossier',
      metadata: 'metadata/getInitialMetadata',
      allCategories: 'metadata/getMetadataItemCategories'
    }),
    localIsModalOpen: {
      get() {
        return this.isModalOpen
      },
      set(value) {
        this.$emit('update:is-modal-open', value)
      }
    },
    event() {
      return this.dossier.events?.find((event) => event.id === this.eventId)
    }
  },
  async mounted() {
    await this.fetchItemsByPlace()
  },
  methods: {
    ...mapActions({
      processFetchFetchItemsByPlaceAction: 'wiki/fetchFetchItemsByPlace',
      processFetchDossierByIdAction: 'dossier/fetchDossierByID',
      processAddWikiItemsToModelAction: 'dossier/addWikiItemsToModel',
      processAddItemsToDossierAction: 'dossier/addItemsToDossier',
      processLinkWikiItemToItemAction: 'item/linkWikiItemToItem',
      processAddItemsToModelAction: 'dossier/addItemsToModel'
    }),
    fetchItemsByPlace() {
      const routeName = this.$route.name
      const payload = {
        place_id: this.placeId
      }

      if (routeName === 'dossier_form_information_route_edit') {
        payload.dossier_id = this.dossier?.id
      }

      this.processFetchFetchItemsByPlaceAction(payload)
        .then((response) => {
          this.items = response.items
          if (response.itemIds) {
            this.itemIds = response.itemIds
          } else {
            this.itemIds = this.event.items?.map((item) => item.wiki_item_id)
          }
        })
        .catch((error) => {
          console.error('fetchItemsByPlace error:', error)
        })
    },

    async handleSelectedItems() {
      try {
        const isDossierRoute =
          this.$route.name === 'dossier_form_information_route_edit'

        const payload = {
          modelId: isDossierRoute ? this.dossier?.id : this.eventId,
          modelType: isDossierRoute ? 'dossier' : 'event',
          items: this.selectedItems
        }
        const response = await this.processAddWikiItemsToModelAction(payload)

        if (response.original) {
          this.originalRequest = response.original
          this.locations = response.locations
          this.chooseStockFromLocationModal = true
        } else {
          this.localIsModalOpen = false
          this.$h.toastSuccess(this.$t('toasts.add_items_to_dossier'))
        }
      } catch (error) {
        console.error('handleSelectedItems error:', error)
      }
    },

    handleLinkItem(item) {
      this.itemToLink = item
      this.openItemsModal = true
    },
    async linkWikiItemToItem(item) {
      try {
        await this.processLinkWikiItemToItemAction({
          item_id: item.selectedItem.item.id,
          wiki_item_id: this.itemToLink.id
        })

        this.$h.toastSuccess(this.$t('toasts.link_item_success'))

        await this.fetchItemsByPlace()

        this.openItemsModal = false
      } catch (error) {
        console.log(error)
      }
    },

    handleSaveWikiItemToDossier({ type, selectedItem, selectPrice }) {
      const isDossierRoute =
        this.$route.name === 'dossier_form_information_route_edit'
      if (isDossierRoute) {
        this.processAddItemsToDossierAction({
          data: {
            items: selectedItem
          },
          id: this.dossier.id
        }).then((response) => {
          this.chooseStockFromLocationModal = false
          this.localIsModalOpen = false
          this.$h.toastSuccess(this.$t('toasts.add_items_to_dossier'))
        })
      } else {
        this.processAddItemsToModelAction({
          data: {
            items: selectedItem,
            type: 'App\\Models\\Event'
          },
          id: this.eventId
        }).then((response) => {
          this.$h.toastSuccess(this.$t('toasts.add_items_to_dossier'))
          this.chooseStockFromLocationModal = false
          this.localIsModalOpen = false
        })
      }
    }
  }
}
</script>
